module.exports = "img/logo.png";